/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Privacy View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './privacyView';

export const mapStateToPropsPrivacyView = mapStateToProps;
export const mapDispatchToPropsPrivacyView = mapDispatchToProps;

export default connect(
  mapStateToPropsPrivacyView,
  mapDispatchToPropsPrivacyView
)(View);
